// import * as React from 'react';
import Button from "@mui/material/Button";
//import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { Typography } from "@mui/material";

const SetDebugActionDialog = () => {
	const [open, setOpen] = useState(true);
	const pendingDebugAction = localStorage.getItem(
		"store.solitairetripeaks.com:debugAction"
	);

	// const handleClose = () => {
	// 	localStorage.removeItem("store.solitairetripeaks.com:debugAction");
	// 	setOpen(false);
	// };

	const handleAccept = async () => {
		window.location.replace(
			location.pathname + "?debugactionid=" + pendingDebugAction
		);
		setOpen(false);
		localStorage.removeItem("store.solitairetripeaks.com:debugAction");
	};

	return (
		<div>
			<Dialog
				fullWidth
				open={open}
				//onClose={handleClose}
				sx={{ zIndex: 99999, fontSize: "18px" }}
			>
				<DialogTitle sx={{ fontSize: "1em" }}>
					Debug action will now execute:
				</DialogTitle>
				<DialogContent sx={{ padding: "0 1.34em" }}>
					<Typography
						variant="subtitle1"
						sx={{
							fontSize: "0.9em",
							color: "blueviolet",
							wordWrap: "break-word"
						}}
					>
						{pendingDebugAction}
					</Typography>
					{/* <TextField
						autoFocus
						margin="dense"
						id="name"
						value={pendingDebugAction}
						type="text"
						fullWidth
						variant="standard"
					/> */}
				</DialogContent>
				<DialogActions>
					{/* <Button onClick={handleClose}>Cancel</Button> */}
					<Button onClick={handleAccept}>Continue</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SetDebugActionDialog;
